import script from "./qr-dialog.vue?vue&type=script&lang=ts&setup=true&name=QrDialog"
export * from "./qr-dialog.vue?vue&type=script&lang=ts&setup=true&name=QrDialog"

const __exports__ = script;

export default __exports__